import { useEffect, useRef, useState } from 'react'
import { Select, Input, Typography } from 'components'
import ItemMaterial from './ItemMaterial'
import { SimulateDraft, Material } from 'container/SalesOrder/interfaces'
import * as S from './styles'
import { SelectChangeEvent } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { URL_CONST } from 'constants/urls'
import statusRascunho from 'constants/statusRascunho'
import { availableCentersFactoriesFilter } from 'constants/enums'

type SimulateOrderProps = {
  data: SimulateDraft
}

const SimulateOrder = ({ data }: SimulateOrderProps) => {
  const navigate = useNavigate()
  const { orderNumber } = useParams()
  const [filterFactory, setFilterFactory] = useState('todos')
  const [filterName, setFilterName] = useState('')
  const [searchResults, setSearchResults] = useState<SimulateDraft>(data)

  const cardRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setSearchResults(data)
    if (!data.materiais.length) {
      navigate(`${URL_CONST.ORDERS}/${orderNumber}`)
      return
    }
  }, [data])

  useEffect(() => {
    if (cardRef.current) {
      window.scrollTo({
        top: cardRef.current.offsetTop,
        behavior: 'smooth'
      })
    }
  }, [cardRef.current])

  const handleFactoryFilter = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string

    setFilterFactory(value)
    filterMaterials(filterName, value)
  }

  const handleNameFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value as string

    setFilterName(value)
    filterMaterials(value, filterFactory)
  }

  const compareMaterials = (a: Material, b: Material) => {
    const materialA = a.stat.toUpperCase()
    const materialB = b.stat.toUpperCase()
    if (materialA === statusRascunho.ANSWERED && materialB !== statusRascunho.ANSWERED) {
      return 1
    } else if (
      materialA === statusRascunho.ANSWERED &&
      materialB === statusRascunho.ANSWERED
    ) {
      return 0
    } else if (
      materialA !== statusRascunho.ANSWERED &&
      materialB === statusRascunho.ANSWERED
    ) {
      return -1
    } else {
      if (materialA > materialB) {
        return 1
      } else if (materialB > materialA) {
        return -1
      }
    }
    return 0
  }

  const sortMaterials = (materials: Material[]) => {
    return materials.slice().sort(compareMaterials)
  }

  const filterMaterials = (name: string, factory: string) => {
    const filteredMaterials = data.materiais.filter((material) => {
      if (factory !== 'todos' && name !== '') {
        return (
          material.ds_matr.toLowerCase().includes(name.toLowerCase()) &&
          material.cota.cd_cent_matr.toLowerCase().includes(factory.toLowerCase())
        )
      } else if (factory !== 'todos' && name === '') {
        return material.cota.cd_cent_matr.toLowerCase().includes(factory.toLowerCase())
      } else if (factory === 'todos' && name !== '') {
        return (
          material.ds_matr.toLowerCase().includes(name.toLowerCase()) ||
          material.cores.some((cor) =>
            cor.ds_cor.toLowerCase().includes(name.toLowerCase())
          )
        )
      }

      return true
    })

    setSearchResults((prevState) => ({
      ...prevState,
      materiais: filteredMaterials
    }))
  }

  return (
    <>
      <S.CardMaterial ref={cardRef}>
        <S.BoxColumn>
          <div className="deliveryHeader">
            <Typography className="materialTitle" design="hav-h5-text">
              Materiais
            </Typography>
            <Select
              name="fabrica"
              label="Fábrica/Centro"
              value={filterFactory}
              onChange={(e) => handleFactoryFilter(e)}
              options={availableCentersFactoriesFilter}
            />
            <div>
              <Input
                label="Buscar materiais"
                value={filterName}
                onChange={handleNameFilter}
                InputProps={{ placeholder: 'Digite aqui o material ou cor' }}
              />
            </div>
          </div>
          <div>
            {sortMaterials(searchResults.materiais).map((material) => (
              <ItemMaterial
                key={`${material.cd_matr}-${material.nr_item_pedi_rasc}`}
                material={material}
              />
            ))}
          </div>
        </S.BoxColumn>
      </S.CardMaterial>
    </>
  )
}

export default SimulateOrder
